module.exports = __webpack_public_path__ + "img/bitkub.4f6ab56b.png";